import capitalize from 'lodash/capitalize';

import { Avatar, AvatarFallback, AvatarImage } from '@/components/ui/avatar';

type UserLike =
  | {
      display_name?: string;
      identifier?: string;
      metadata?: Record<string, unknown>;
    }
  | null
  | undefined;

type Props = {
  user: UserLike;
};

export default function UserSidebarHeader({ user }: Props) {
  const displayName = user?.display_name || user?.identifier || '—';
  const identifier =
    user?.identifier && user.identifier !== displayName ? user.identifier : null;
  const email =
    typeof user?.metadata?.email === 'string'
      ? (user.metadata.email as string)
      : null;
  const subtitle = email || identifier;
  const avatarSrc =
    typeof user?.metadata?.image === 'string'
      ? (user.metadata.image as string)
      : undefined;
  const initial = displayName.charAt(0) || '?';

  return (
    <div className="flex items-center gap-3 px-5 py-4 pr-12 border-b border-border">
      <Avatar className="h-12 w-12">
        <AvatarImage src={avatarSrc} alt="User avatar" />
        <AvatarFallback className="bg-primary text-primary-foreground text-base font-semibold">
          {capitalize(initial)}
        </AvatarFallback>
      </Avatar>
      <div className="flex-1 min-w-0">
        <p className="text-base font-semibold text-foreground truncate">
          {displayName}
        </p>
        {subtitle && (
          <p className="text-xs text-muted-foreground truncate">{subtitle}</p>
        )}
      </div>
    </div>
  );
}
